import { ConfirmModal } from '../../../components/modal/confirm-modal';
import Icon from '../../../components/icons/icon';
import { Admin } from '../../../clients/quipli-service/admin/admin';
import { useAdminOperations } from '../hooks/use-admin-operations';

interface DeleteAdminModalProps {
  admin: Admin | null;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const DeleteAdminModal = ({ admin, isOpen, onClose, onSuccess }: DeleteAdminModalProps) => {
  const { deleteUser, isDeleting } = useAdminOperations();

  const handleDelete = async () => {
    if (!admin || isDeleting) return;

    try {
      await deleteUser(admin.adminId);
      onSuccess();
      onClose();
    } catch (error) {
      // Error handling is done in the hook, so we just close the modal
      onClose();
    }
  };

  if (!isOpen || !admin) return null;

  return (
    <ConfirmModal
      isOpen={isOpen}
      close={onClose}
      onConfirm={handleDelete}
      headerIcon={
        <div className="flex justify-center">
          <Icon icon="XCircle" size="xlarge" stroke="var(--error-500)" />
        </div>
      }
      prompt="Remove user?"
      yesDataCy="admin-delete-button"
      noDataCy="admin-cancel-button"
    />
  );
};
